import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { resolveRoute } from '@domain/auth/AdminUser';
import { useAuth } from '@app/hooks/useAuth';

interface Props {
  children: ReactElement;
}

export function ProtectedRoute({ children }: Props) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-sm text-gray-500">Loading…</div>;
  const route = resolveRoute(user);
  if (route === 'login') return <Navigate to="/login" replace />;
  if (route === 'forbidden') return <Navigate to="/forbidden" replace />;
  return children;
}
